import { View, ImageScaleView, ViewOpts } from '@play-co/timestep-core/ui';
import { Match2Timer } from 'src/game/minigame/match2-timestep/components/Match2Timer';
import {
  BuddiesEventStatus,
  buddiesGetRemainingTime,
} from 'src/replicant/buddies/buddies.getters';
import i18n from 'src/lib/i18n/i18n';
import StateObserver from 'src/StateObserver';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { assertNever } from 'src/replicant/utils';

export class BuddiesTitle extends View {
  private title: ImageScaleView;
  private message: LangBitmapFontTextView;
  public timer: Match2Timer;

  constructor(opts: ViewOpts) {
    super({
      ...opts,
    });

    const locale = StateObserver.getLocale();

    this.title = new ImageScaleView({
      superview: this,
      width: 300,
      height: 140,
      scaleMethod: 'contain',
      image: `assets/ui/buddies/common/title_${locale}.png`,
      centerOnOrigin: true,
    });

    this.timer = new Match2Timer({
      superview: this,
      x: 0,
      y: 100,
      centerOnOrigin: true,
    });
    this.timer.setRemainingTimeGetter(buddiesGetRemainingTime);

    this.message = new LangBitmapFontTextView({
      superview: this,
      align: 'center',
      verticalAlign: 'center',
      size: 26,
      font: 'Title',
      color: '#FFFFFF',
      width: 300,
      height: 50,
      centerOnOrigin: true,
      x: this.style.width / 2,
      y: 83,
    });
  }

  public updateEventStatus(status: BuddiesEventStatus) {
    switch (status) {
      case 'inProgress':
      case 'overPendingScore':
      case 'overPendingCollect':
        this.eventInProgress();
        break;
      case 'overClaimed':
      case 'overNoClaim':
      case 'unavailable':
        this.eventOver();
        break;
      default:
        assertNever(status);
    }
  }

  private eventInProgress() {
    this.timer.show();
    this.message.hide();
  }

  private eventOver() {
    this.timer.hide();
    this.message.show();
    this.message.localeText = () => i18n('match2.buddies.eventOver');
  }
}
